import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import styles from '../../../../styles/icons/logos/molson-predictions.module.scss';

import logo from '../../../../img/nhl/molson-predictions.png';
import tag from '../../../../img/nhl/molson-tag.png';

const propTypes = {
    rcshow: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    rcshow: false,
    className: null,
};

function MolsonPredictions({ className, rcshow }) {
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            {rcshow ? <div className={styles.badge}>RC Show Edition</div> : null}
            <img src={logo} alt="Molson Predictions" className={styles.logo} />
            {!rcshow ? (
                <div className={styles.bottom}>
                    <div className={styles.text}>
                        <FormattedMessage
                            defaultMessage="Play to win your VIP trip to Edmonton Heritage Classic"
                            description="Molson logo tag text"
                        />
                    </div>
                    <img src={tag} alt="Molson Predictions" className={styles.tag} />
                </div>
            ) : null}
        </div>
    );
}

MolsonPredictions.propTypes = propTypes;
MolsonPredictions.defaultProps = defaultProps;

export default MolsonPredictions;
